// Lib
import React from 'react';
import { Button as RomaButton, UtilityButton } from '@milanote/roma';
import { EditorToolbar } from '@milanote/roma/application';

// Components
import Icon from '../../../../../components/icons/Icon';

// Hooks
import { useTranslator } from '../../../../../components/i18n/useTranslator';

type ImageModalV2EditorToolbarProps = {
    cropActive: boolean;
    disabled: boolean;
    onCropClick: () => void;
    onRotateClick: () => void;
    onCancelClick: () => void;
    onSaveClick: () => void;
};

const ImageModalV2EditorToolbar: React.FC<ImageModalV2EditorToolbarProps> = ({
    cropActive,
    disabled,
    onCropClick,
    onRotateClick,
    onCancelClick,
    onSaveClick,
}) => {
    const translate = useTranslator('popup', 'imageModal.editor');
    const drawingTranslate = useTranslator('popup', 'drawing');

    return (
        <EditorToolbar.Shell>
            <EditorToolbar.List>
                <UtilityButton
                    isSelected={cropActive}
                    onPress={onCropClick}
                    isDisabled={disabled}
                    tooltip={{ title: 'Crop' }}
                >
                    <Icon name="image-modal-editor-crop" />
                </UtilityButton>

                <UtilityButton
                    onPress={onRotateClick}
                    isDisabled={disabled}
                    tooltip={{ title: translate('rotateLeft') }}
                >
                    <Icon name="image-modal-editor-rotate" />
                </UtilityButton>

                <UtilityButton onPress={undefined} isDisabled={disabled} tooltip={{ title: 'Flip horizontal' }}>
                    <Icon name="image-modal-editor-flip-horizontal" />
                </UtilityButton>

                <UtilityButton onPress={undefined} isDisabled={disabled} tooltip={{ title: 'Flip vertical' }}>
                    <Icon name="image-modal-editor-flip-vertical" />
                </UtilityButton>

                <EditorToolbar.Divider type="spacer" />

                <div className="flex shrink-0 items-center gap-sm">
                    <RomaButton color="secondary" onClick={onCancelClick}>
                        {drawingTranslate('discard')}
                    </RomaButton>

                    <RomaButton onClick={onSaveClick} isDisabled={disabled}>
                        {translate('save')}
                    </RomaButton>
                </div>
            </EditorToolbar.List>
        </EditorToolbar.Shell>
    );
};

export default ImageModalV2EditorToolbar;
